var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNimbusInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306 420.187H601.875V490.5H306V420.187ZM306 552.938H601.875V623.25H306V552.938ZM306 285.188H601.875V355.5H306V285.188Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M637.875 56.25L542.25 15.75L454.5 56.25L360.562 15.75L272.25 56.25L138.375 0V900L272.25 843.75L360.562 882.562L454.5 843.75L542.25 882.562L637.875 843.75L761.625 900V0L637.875 56.25ZM690.75 793.688L639 770.625L543.938 809.438L455.625 768.938L361.125 807.75L273.937 768.938L209.25 795.375V104.625L273.937 131.062L361.125 92.25L455.625 131.062L543.938 92.25L639 131.062L690.75 108V793.688Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNimbusInvoice);
export default __webpack_public_path__ + "static/media/nimbus_invoice.4bdf6b03.svg";
export { ForwardRef as ReactComponent };